import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { MessageCircle } from 'lucide-react';
import ImagePreviewModal from '../../../components/ImagePreviewModal';
import previewStyles from './ChatImagePreviewModal.module.css';

const formatPreviewTimestamp = (timestamp) => {
  if (!timestamp) return null;
  const date =
    typeof timestamp.toDate === 'function'
      ? timestamp.toDate()
      : timestamp instanceof Date
      ? timestamp
      : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return null;
  return format(date, 'h:mm a');
};

const ChatImagePreviewModal = ({
  imageUrl,
  images,
  initialIndex = 0,
  onClose,
  onReply,
  senderName,
  timestamp,
  senderAvatar,
  showContext = true,
}) => {
  const { t } = useTranslation();
  const hasContext = showContext && senderName;
  const previewTimestamp = formatPreviewTimestamp(timestamp);

  const headerContent = hasContext ? (
    <div className={previewStyles.senderInfo}>
      <div className={previewStyles.senderAvatar}>
        {senderAvatar ? (
          <img src={senderAvatar} alt="" />
        ) : (
          <span>{senderName?.[0]?.toUpperCase()}</span>
        )}
      </div>
      <div className={previewStyles.senderMeta}>
        <span className={previewStyles.senderName}>{senderName}</span>
        {previewTimestamp && (
          <span className={previewStyles.timestamp}>{previewTimestamp}</span>
        )}
      </div>
    </div>
  ) : null;

  const footerActions = onReply
    ? ({ tabIndex }) => (
        <button
          className={previewStyles.actionButton}
          type="button"
          onClick={onReply}
          aria-label={t('chat.reply', 'Reply')}
          tabIndex={tabIndex}
        >
          <MessageCircle size={22} />
        </button>
      )
    : null;

  const shareTitle = hasContext
    ? t('chat.photo_from', 'Photo from {{name}}', { name: senderName })
    : t('common.shared_photo', 'Shared photo');

  return (
    <ImagePreviewModal
      imageUrl={imageUrl}
      images={images}
      initialIndex={initialIndex}
      onClose={onClose}
      headerContent={headerContent}
      footerActions={footerActions}
      shareTitle={shareTitle}
    />
  );
};

export default ChatImagePreviewModal;
